var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekSelection } from "../inputs/RecekSelection";
import { usePublishersData } from "../../hooks/usePublishersData";
import { formatPublisherLabel } from "../../utils/publisherLabel";
export var BulkVerifyTitlesDialog = function (_a) {
    var open = _a.open, selectedCount = _a.selectedCount, onClose = _a.onClose, onSubmit = _a.onSubmit, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var _c = useState(""), publisherQuery = _c[0], setPublisherQuery = _c[1];
    var _d = useState(""), publisherId = _d[0], setPublisherId = _d[1];
    var _e = usePublishersData(publisherQuery, publisherId), publishers = _e.publishers, isPublishersLoading = _e.isPublishersLoading;
    useEffect(function () {
        if (!open) {
            setPublisherQuery("");
            setPublisherId("");
        }
    }, [open]);
    var publisherOptions = useMemo(function () {
        var entries = publishers.map(function (p) { return ({
            value: p.id || "",
            label: formatPublisherLabel(p),
        }); });
        return __spreadArray([
            {
                value: "",
                label: formatMessage({
                    id: "ui-br-legaldeposits.collectionsList.select.option.all",
                }),
            }
        ], entries, true);
    }, [publishers, formatMessage]);
    var handleClose = useCallback(function () {
        setPublisherQuery("");
        setPublisherId("");
        onClose();
    }, [onClose]);
    var handleSubmit = useCallback(function () {
        onSubmit(publisherId);
    }, [publisherId, onSubmit]);
    var isValid = publisherId !== "" && selectedCount > 0;
    return (React.createElement(Modal, { open: open, label: formatMessage({
            id: "ui-br-legaldeposits.bulk.verify.title",
        }), onClose: handleClose, size: "small", footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: handleSubmit, disabled: !isValid || isLoading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.confirm" })),
            React.createElement(Button, { onClick: handleClose },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.button.cancel" }))) },
        React.createElement(MessageBanner, { type: "warning" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.bulk.verify.summary", values: { count: selectedCount } })),
        React.createElement(RecekSelection, { labelId: "ui-br-legaldeposits.title.label.publisher", name: "bulkPublisher", value: publisherId, asyncFilter: true, loading: isPublishersLoading, onFilter: function (val) { return setPublisherQuery(val); }, onChange: function (id) { return setPublisherId(id); }, dataOptions: publisherOptions, required: true })));
};
